import type { AxiosResponse } from 'axios';

type ToFileResponse = Pick<AxiosResponse<BlobPart>, 'data' | 'headers'>;

type ToFileOptions = {
  defaultFilename?: string;
  defaultMimeType?: string;
};

/**
 * Returns a JS file from a full Axios response
 * @param response axios full response (including headers)
 * @returns JS file
 */
export function toFile(response: ToFileResponse, options: ToFileOptions = {}) {
  const { defaultFilename = 'file', defaultMimeType = 'text/html' } = options;
  const { data, headers } = response;
  let filename = defaultFilename;

  // TODO: use a more robust library (e.g. `content-disposition`) to parse key-value pair and content type.  For now, we just have to softly agree with backend that the format of content-type and content-disposition is kept to a consistent interface
  const contentType = headers['content-type'] as string | undefined;
  const contentDisposition = headers['content-disposition'] as
    | string
    | undefined;

  const type = contentType ? contentType.split(';')[0] : defaultMimeType;

  if (contentDisposition) {
    const filenameMatch = /filename=(.*)/.exec(contentDisposition);
    if (filenameMatch) {
      filename = filenameMatch[1].replaceAll(/^"+|"+$/g, '');
    }
  }

  return new File([data], filename, { type });
}
